export class SaveCustomer {
    constructor() {
        this.saveCustomer = async (customer) => {
            const apiUrl = process.env.REACT_APP_API_URL;
            try {
                const url = new URL(`/customers`, apiUrl);
                const response = await fetch(url.toString(), {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(customer)
                });
                const data = await response.json();
                return data;
            }
            catch (error) {
                return console.error(error);
            }
        };
    }
}
